import { account } from '../../../../../classes/Account'

function renderFormattedText(text) {
  return text.split('\\n').map((line, index) => {
    const parts = []
    let remaining = line
    let match

    const brRegex = /<br>(.*?)<\/br>/
    const boldRegex = /<b>(.*?)<\/b>/

    while ((match = brRegex.exec(remaining))) {
      const [fullMatch, styledText] = match
      const before = remaining.slice(0, match.index)
      if (before) parts.push(before)
      parts.push(
        <strong
          key={`${index}-br-${parts.length}`}
          className='text-xl underline italic'
        >
          {styledText}
        </strong>
      )
      remaining = remaining.slice(match.index + fullMatch.length)
    }

    while ((match = boldRegex.exec(remaining))) {
      const [fullMatch, boldText] = match
      const before = remaining.slice(0, match.index)
      if (before) parts.push(before)
      parts.push(
        <strong
          key={`${index}-b-${parts.length}`}
          className='text-xl'
        >
          {boldText}
        </strong>
      )
      remaining = remaining.slice(match.index + fullMatch.length)
    }

    if (remaining) parts.push(remaining)

    return <p key={index}>{parts}</p>
  })
}

export default function DashboardProgressTile({ description }) {
  let displayText = description

  if (description.startsWith('withPEO')) {
    const parts = description.split('|')
    const peoPart = parts[0]?.replace(/^withPEO\s?\?/, '').trim()
    const nonPeoPart = parts[1]?.trim()
    displayText = account.withPEO === 'Yes' ? peoPart : nonPeoPart
  } else if (description.startsWith('APPLICATION')) {
    const parts = description.split('|')
    const accelerate = parts[0]?.replace(/^APPLICATION\s?\?/, '').trim()
    const accelerateBuyout = parts[1]?.trim()
    const buyout = parts[2]?.trim()

    if (account.withPEO === 'No' && account.remainingERCCredits < 100000)
      displayText = accelerate
    else if (account.withPEO === 'No' && account.remainingERCCredits >= 100000)
      displayText = accelerateBuyout
    else
      displayText = buyout
  }

  return (
    <div className='w-full sm:w-1/3 p-6 rounded-2xl bg-white dark:bg-slate-800 border border-gray-100 dark:border-slate-700 shadow-sm flex flex-col gap-4 text-slate-800 dark:text-gray-100 transition-colors duration-300 leading-relaxed text-sm xl:text-base'>
      {renderFormattedText(displayText)}
    </div>
  )
}